export const MAP_EDIT_VIEW_TYPE = 'retailTripMapEdit';

export enum MAP_EDIT_BUCKETS {
  MAP_TRIPS = 'map_view_trips',
  MAP_UNPLANNED = 'map_view_unplanned',
  DRIVERS = 'drivers',
}
